import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiAwaitBusAssetImageProcessingParams,
  ApiGetBusAssetsParams,
  AssetEntity,
  AttributeValuesResponseDto,
  AwaitBusAssetImageProcessingResponseDto,
  BackendErrorEntity,
  BusAssetEntity,
  BusAssetWithSaleEntity,
  DeleteBusAssetBaseImageBodyDto,
  DeleteBusAssetCoverImageBodyDto,
  DeleteBusAssetDamageImageBodyDto,
  DeleteBusAssetVideoBodyDto,
  GetBusAssetsResponseDto,
  InpaintBusAssetImageBodyDto,
  PostCloneAlreadySoldBusAssetBodyDto,
  PostCloneBusAssetBodyDto,
  SetBusAssetImageDetailFlagBodyDto,
  UpdateBusAssetBodyDto,
  UploadBusAssetBaseImageBodyDto,
  UploadBusAssetCocDocumentBodyDto,
  UploadBusAssetCoverImageBodyDto,
  UploadBusAssetDamageImageBodyDto,
  UploadBusAssetInspectionAndMileageCheckBodyDto,
  UploadBusAssetInspectionStickerBodyDto,
  UploadBusAssetMaintenanceCardBodyDto,
  UploadBusAssetRegistrationDocumentBodyDto,
  UploadBusAssetRegistrationDocumentPartTwoBodyDto,
  UploadBusAssetTechnicalSheetBodyDto,
  UploadBusAssetVideoBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiAttributeValues = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<AttributeValuesResponseDto>(
      {url: `/busAssets/attributeValues`, method: 'GET'
    },
      options);
    }
  

export const getApiAttributeValuesQueryKey = () => {
    return ['busAssets','attributeValues'] as const;
    }

    
export const getApiAttributeValuesQueryOptions = <TData = Awaited<ReturnType<typeof apiAttributeValues>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAttributeValues>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAttributeValuesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAttributeValues>>> = () => apiAttributeValues(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAttributeValues>>, TError, TData> 
}

export type ApiAttributeValuesQueryResult = NonNullable<Awaited<ReturnType<typeof apiAttributeValues>>>
export type ApiAttributeValuesQueryError = ErrorType<BackendErrorEntity>



export function useApiAttributeValues<TData = Awaited<ReturnType<typeof apiAttributeValues>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAttributeValues>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAttributeValuesQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiExportBusAssetImages = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<void>(
      {url: `/busAssets/${busAssetId}/images/export`, method: 'POST'
    },
      options);
    }
  


export const getApiExportBusAssetImagesMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiExportBusAssetImages>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiExportBusAssetImages>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiExportBusAssetImages>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiExportBusAssetImages(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiExportBusAssetImagesMutationResult = NonNullable<Awaited<ReturnType<typeof apiExportBusAssetImages>>>
    
    export type ApiExportBusAssetImagesMutationError = ErrorType<BackendErrorEntity>

    export const useApiExportBusAssetImages = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiExportBusAssetImages>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiExportBusAssetImages>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiExportBusAssetImagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUpdateBusAsset = (
    busAssetId: MaybeRef<string | undefined | null>,
    updateBusAssetBodyDto: MaybeRef<UpdateBusAssetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
updateBusAssetBodyDto = unref(updateBusAssetBodyDto);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBusAssetBodyDto
    },
      options);
    }
  


export const getApiUpdateBusAssetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateBusAsset>>, TError,{busAssetId: string;data: BodyType<UpdateBusAssetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateBusAsset>>, TError,{busAssetId: string;data: BodyType<UpdateBusAssetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateBusAsset>>, {busAssetId: string;data: BodyType<UpdateBusAssetBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUpdateBusAsset(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateBusAssetMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateBusAsset>>>
    export type ApiUpdateBusAssetMutationBody = BodyType<UpdateBusAssetBodyDto>
    export type ApiUpdateBusAssetMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateBusAsset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateBusAsset>>, TError,{busAssetId: string;data: BodyType<UpdateBusAssetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateBusAsset>>,
        TError,
        {busAssetId: string;data: BodyType<UpdateBusAssetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateBusAssetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetBusAsset = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetWithSaleEntity>(
      {url: `/busAssets/${busAssetId}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetBusAssetQueryKey = (busAssetId: MaybeRef<string | undefined | null>,) => {
    return ['busAssets',busAssetId] as const;
    }

    
export const getApiGetBusAssetQueryOptions = <TData = Awaited<ReturnType<typeof apiGetBusAsset>>, TError = ErrorType<BackendErrorEntity>>(busAssetId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBusAsset>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetBusAssetQueryKey(busAssetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetBusAsset>>> = () => apiGetBusAsset(busAssetId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(busAssetId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetBusAsset>>, TError, TData> 
}

export type ApiGetBusAssetQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetBusAsset>>>
export type ApiGetBusAssetQueryError = ErrorType<BackendErrorEntity>



export function useApiGetBusAsset<TData = Awaited<ReturnType<typeof apiGetBusAsset>>, TError = ErrorType<BackendErrorEntity>>(
 busAssetId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBusAsset>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetBusAssetQueryOptions(busAssetId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUploadBusAssetRegistrationDocument = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetRegistrationDocumentBodyDto: MaybeRef<UploadBusAssetRegistrationDocumentBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetRegistrationDocumentBodyDto = unref(uploadBusAssetRegistrationDocumentBodyDto);
      const formData = new FormData();
formData.append('busAssetRegistrationDocument', uploadBusAssetRegistrationDocumentBodyDto.busAssetRegistrationDocument)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/registrationDocument`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetRegistrationDocumentMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocument>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocument>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocument>>, {busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetRegistrationDocument(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetRegistrationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocument>>>
    export type ApiUploadBusAssetRegistrationDocumentMutationBody = BodyType<UploadBusAssetRegistrationDocumentBodyDto>
    export type ApiUploadBusAssetRegistrationDocumentMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetRegistrationDocument = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocument>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocument>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetRegistrationDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetRegistrationDocument = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/registrationDocument`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteBusAssetRegistrationDocumentMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocument>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocument>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocument>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiDeleteBusAssetRegistrationDocument(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetRegistrationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocument>>>
    
    export type ApiDeleteBusAssetRegistrationDocumentMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetRegistrationDocument = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocument>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocument>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetRegistrationDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetRegistrationDocumentPartTwo = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetRegistrationDocumentPartTwoBodyDto: MaybeRef<UploadBusAssetRegistrationDocumentPartTwoBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetRegistrationDocumentPartTwoBodyDto = unref(uploadBusAssetRegistrationDocumentPartTwoBodyDto);
      const formData = new FormData();
formData.append('busAssetRegistrationDocumentPartTwo', uploadBusAssetRegistrationDocumentPartTwoBodyDto.busAssetRegistrationDocumentPartTwo)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/registrationDocumentPartTwo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetRegistrationDocumentPartTwoMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocumentPartTwo>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentPartTwoBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocumentPartTwo>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentPartTwoBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocumentPartTwo>>, {busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentPartTwoBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetRegistrationDocumentPartTwo(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetRegistrationDocumentPartTwoMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocumentPartTwo>>>
    export type ApiUploadBusAssetRegistrationDocumentPartTwoMutationBody = BodyType<UploadBusAssetRegistrationDocumentPartTwoBodyDto>
    export type ApiUploadBusAssetRegistrationDocumentPartTwoMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetRegistrationDocumentPartTwo = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocumentPartTwo>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentPartTwoBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetRegistrationDocumentPartTwo>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetRegistrationDocumentPartTwoBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetRegistrationDocumentPartTwoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetRegistrationDocumentPartTwo = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/registrationDocumentPartTwo`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteBusAssetRegistrationDocumentPartTwoMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocumentPartTwo>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocumentPartTwo>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocumentPartTwo>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiDeleteBusAssetRegistrationDocumentPartTwo(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetRegistrationDocumentPartTwoMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocumentPartTwo>>>
    
    export type ApiDeleteBusAssetRegistrationDocumentPartTwoMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetRegistrationDocumentPartTwo = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocumentPartTwo>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetRegistrationDocumentPartTwo>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetRegistrationDocumentPartTwoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetMaintenanceCard = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetMaintenanceCardBodyDto: MaybeRef<UploadBusAssetMaintenanceCardBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetMaintenanceCardBodyDto = unref(uploadBusAssetMaintenanceCardBodyDto);
      const formData = new FormData();
formData.append('busAssetMaintenanceCard', uploadBusAssetMaintenanceCardBodyDto.busAssetMaintenanceCard)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/maintenanceCard`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetMaintenanceCardMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetMaintenanceCard>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetMaintenanceCardBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetMaintenanceCard>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetMaintenanceCardBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetMaintenanceCard>>, {busAssetId: string;data: BodyType<UploadBusAssetMaintenanceCardBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetMaintenanceCard(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetMaintenanceCardMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetMaintenanceCard>>>
    export type ApiUploadBusAssetMaintenanceCardMutationBody = BodyType<UploadBusAssetMaintenanceCardBodyDto>
    export type ApiUploadBusAssetMaintenanceCardMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetMaintenanceCard = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetMaintenanceCard>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetMaintenanceCardBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetMaintenanceCard>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetMaintenanceCardBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetMaintenanceCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetMaintenanceCard = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/maintenanceCard`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteBusAssetMaintenanceCardMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetMaintenanceCard>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetMaintenanceCard>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetMaintenanceCard>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiDeleteBusAssetMaintenanceCard(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetMaintenanceCardMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetMaintenanceCard>>>
    
    export type ApiDeleteBusAssetMaintenanceCardMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetMaintenanceCard = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetMaintenanceCard>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetMaintenanceCard>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetMaintenanceCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetCocDocument = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetCocDocumentBodyDto: MaybeRef<UploadBusAssetCocDocumentBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetCocDocumentBodyDto = unref(uploadBusAssetCocDocumentBodyDto);
      const formData = new FormData();
formData.append('busAssetCocDocument', uploadBusAssetCocDocumentBodyDto.busAssetCocDocument)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/cocDocument`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetCocDocumentMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetCocDocument>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetCocDocumentBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetCocDocument>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetCocDocumentBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetCocDocument>>, {busAssetId: string;data: BodyType<UploadBusAssetCocDocumentBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetCocDocument(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetCocDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetCocDocument>>>
    export type ApiUploadBusAssetCocDocumentMutationBody = BodyType<UploadBusAssetCocDocumentBodyDto>
    export type ApiUploadBusAssetCocDocumentMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetCocDocument = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetCocDocument>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetCocDocumentBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetCocDocument>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetCocDocumentBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetCocDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetCocDocument = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/cocDocument`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteBusAssetCocDocumentMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetCocDocument>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetCocDocument>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetCocDocument>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiDeleteBusAssetCocDocument(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetCocDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetCocDocument>>>
    
    export type ApiDeleteBusAssetCocDocumentMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetCocDocument = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetCocDocument>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetCocDocument>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetCocDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetTechnicalSheet = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetTechnicalSheetBodyDto: MaybeRef<UploadBusAssetTechnicalSheetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetTechnicalSheetBodyDto = unref(uploadBusAssetTechnicalSheetBodyDto);
      const formData = new FormData();
formData.append('busAssetTechnicalSheet', uploadBusAssetTechnicalSheetBodyDto.busAssetTechnicalSheet)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/technicalSheet`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetTechnicalSheetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetTechnicalSheet>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetTechnicalSheetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetTechnicalSheet>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetTechnicalSheetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetTechnicalSheet>>, {busAssetId: string;data: BodyType<UploadBusAssetTechnicalSheetBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetTechnicalSheet(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetTechnicalSheetMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetTechnicalSheet>>>
    export type ApiUploadBusAssetTechnicalSheetMutationBody = BodyType<UploadBusAssetTechnicalSheetBodyDto>
    export type ApiUploadBusAssetTechnicalSheetMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetTechnicalSheet = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetTechnicalSheet>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetTechnicalSheetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetTechnicalSheet>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetTechnicalSheetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetTechnicalSheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetTechnicalSheet = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/technicalSheet`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteBusAssetTechnicalSheetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetTechnicalSheet>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetTechnicalSheet>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetTechnicalSheet>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiDeleteBusAssetTechnicalSheet(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetTechnicalSheetMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetTechnicalSheet>>>
    
    export type ApiDeleteBusAssetTechnicalSheetMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetTechnicalSheet = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetTechnicalSheet>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetTechnicalSheet>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetTechnicalSheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetInspectionAndMileageCheck = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetInspectionAndMileageCheckBodyDto: MaybeRef<UploadBusAssetInspectionAndMileageCheckBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetInspectionAndMileageCheckBodyDto = unref(uploadBusAssetInspectionAndMileageCheckBodyDto);
      const formData = new FormData();
formData.append('busAssetInspectionAndMileageCheck', uploadBusAssetInspectionAndMileageCheckBodyDto.busAssetInspectionAndMileageCheck)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/inspectionAndMileageCheck`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetInspectionAndMileageCheckMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetInspectionAndMileageCheck>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetInspectionAndMileageCheckBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetInspectionAndMileageCheck>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetInspectionAndMileageCheckBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetInspectionAndMileageCheck>>, {busAssetId: string;data: BodyType<UploadBusAssetInspectionAndMileageCheckBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetInspectionAndMileageCheck(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetInspectionAndMileageCheckMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetInspectionAndMileageCheck>>>
    export type ApiUploadBusAssetInspectionAndMileageCheckMutationBody = BodyType<UploadBusAssetInspectionAndMileageCheckBodyDto>
    export type ApiUploadBusAssetInspectionAndMileageCheckMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetInspectionAndMileageCheck = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetInspectionAndMileageCheck>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetInspectionAndMileageCheckBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetInspectionAndMileageCheck>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetInspectionAndMileageCheckBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetInspectionAndMileageCheckMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetInspectionAndMileageCheck = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/inspectionAndMileageCheck`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteBusAssetInspectionAndMileageCheckMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionAndMileageCheck>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionAndMileageCheck>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionAndMileageCheck>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiDeleteBusAssetInspectionAndMileageCheck(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetInspectionAndMileageCheckMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionAndMileageCheck>>>
    
    export type ApiDeleteBusAssetInspectionAndMileageCheckMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetInspectionAndMileageCheck = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionAndMileageCheck>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetInspectionAndMileageCheck>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetInspectionAndMileageCheckMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetInspectionSticker = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetInspectionStickerBodyDto: MaybeRef<UploadBusAssetInspectionStickerBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetInspectionStickerBodyDto = unref(uploadBusAssetInspectionStickerBodyDto);
      const formData = new FormData();
formData.append('busAssetInspectionSticker', uploadBusAssetInspectionStickerBodyDto.busAssetInspectionSticker)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/inspectionSticker`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetInspectionStickerMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetInspectionSticker>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetInspectionStickerBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetInspectionSticker>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetInspectionStickerBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetInspectionSticker>>, {busAssetId: string;data: BodyType<UploadBusAssetInspectionStickerBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetInspectionSticker(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetInspectionStickerMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetInspectionSticker>>>
    export type ApiUploadBusAssetInspectionStickerMutationBody = BodyType<UploadBusAssetInspectionStickerBodyDto>
    export type ApiUploadBusAssetInspectionStickerMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetInspectionSticker = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetInspectionSticker>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetInspectionStickerBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetInspectionSticker>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetInspectionStickerBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetInspectionStickerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetInspectionSticker = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/inspectionSticker`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteBusAssetInspectionStickerMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionSticker>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionSticker>>, TError,{busAssetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionSticker>>, {busAssetId: string}> = (props) => {
          const {busAssetId} = props ?? {};

          return  apiDeleteBusAssetInspectionSticker(busAssetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetInspectionStickerMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionSticker>>>
    
    export type ApiDeleteBusAssetInspectionStickerMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetInspectionSticker = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetInspectionSticker>>, TError,{busAssetId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetInspectionSticker>>,
        TError,
        {busAssetId: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetInspectionStickerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetBaseImage = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetBaseImageBodyDto: MaybeRef<UploadBusAssetBaseImageBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetBaseImageBodyDto = unref(uploadBusAssetBaseImageBodyDto);
      const formData = new FormData();
formData.append('busAssetBaseImage', uploadBusAssetBaseImageBodyDto.busAssetBaseImage)
if(uploadBusAssetBaseImageBodyDto.performTextInpaint !== undefined && uploadBusAssetBaseImageBodyDto.performTextInpaint !== null) {
 formData.append('performTextInpaint', uploadBusAssetBaseImageBodyDto.performTextInpaint)
 }
if(uploadBusAssetBaseImageBodyDto.performTextInpaintPrompt !== undefined && uploadBusAssetBaseImageBodyDto.performTextInpaintPrompt !== null) {
 formData.append('performTextInpaintPrompt', uploadBusAssetBaseImageBodyDto.performTextInpaintPrompt)
 }
if(uploadBusAssetBaseImageBodyDto.anchor !== undefined && uploadBusAssetBaseImageBodyDto.anchor !== null) {
 formData.append('anchor', uploadBusAssetBaseImageBodyDto.anchor)
 }

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/baseImages`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetBaseImageMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetBaseImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetBaseImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetBaseImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetBaseImageBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetBaseImage>>, {busAssetId: string;data: BodyType<UploadBusAssetBaseImageBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetBaseImage(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetBaseImageMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetBaseImage>>>
    export type ApiUploadBusAssetBaseImageMutationBody = BodyType<UploadBusAssetBaseImageBodyDto>
    export type ApiUploadBusAssetBaseImageMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetBaseImage = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetBaseImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetBaseImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetBaseImage>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetBaseImageBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetBaseImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetBaseImage = (
    busAssetId: MaybeRef<string | undefined | null>,
    deleteBusAssetBaseImageBodyDto: MaybeRef<DeleteBusAssetBaseImageBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
deleteBusAssetBaseImageBodyDto = unref(deleteBusAssetBaseImageBodyDto);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/baseImages`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteBusAssetBaseImageBodyDto
    },
      options);
    }
  


export const getApiDeleteBusAssetBaseImageMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetBaseImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetBaseImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetBaseImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetBaseImageBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetBaseImage>>, {busAssetId: string;data: BodyType<DeleteBusAssetBaseImageBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiDeleteBusAssetBaseImage(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetBaseImageMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetBaseImage>>>
    export type ApiDeleteBusAssetBaseImageMutationBody = BodyType<DeleteBusAssetBaseImageBodyDto>
    export type ApiDeleteBusAssetBaseImageMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetBaseImage = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetBaseImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetBaseImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetBaseImage>>,
        TError,
        {busAssetId: string;data: BodyType<DeleteBusAssetBaseImageBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetBaseImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetVideo = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetVideoBodyDto: MaybeRef<UploadBusAssetVideoBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetVideoBodyDto = unref(uploadBusAssetVideoBodyDto);
      const formData = new FormData();
formData.append('busAssetVideo', uploadBusAssetVideoBodyDto.busAssetVideo)

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/videos`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetVideoMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetVideo>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetVideoBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetVideo>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetVideoBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetVideo>>, {busAssetId: string;data: BodyType<UploadBusAssetVideoBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetVideo(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetVideoMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetVideo>>>
    export type ApiUploadBusAssetVideoMutationBody = BodyType<UploadBusAssetVideoBodyDto>
    export type ApiUploadBusAssetVideoMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetVideo = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetVideo>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetVideoBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetVideo>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetVideoBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetVideoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetVideo = (
    busAssetId: MaybeRef<string | undefined | null>,
    deleteBusAssetVideoBodyDto: MaybeRef<DeleteBusAssetVideoBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
deleteBusAssetVideoBodyDto = unref(deleteBusAssetVideoBodyDto);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/videos`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteBusAssetVideoBodyDto
    },
      options);
    }
  


export const getApiDeleteBusAssetVideoMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetVideo>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetVideoBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetVideo>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetVideoBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetVideo>>, {busAssetId: string;data: BodyType<DeleteBusAssetVideoBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiDeleteBusAssetVideo(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetVideoMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetVideo>>>
    export type ApiDeleteBusAssetVideoMutationBody = BodyType<DeleteBusAssetVideoBodyDto>
    export type ApiDeleteBusAssetVideoMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetVideo = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetVideo>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetVideoBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetVideo>>,
        TError,
        {busAssetId: string;data: BodyType<DeleteBusAssetVideoBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetVideoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetDamageImage = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetDamageImageBodyDto: MaybeRef<UploadBusAssetDamageImageBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetDamageImageBodyDto = unref(uploadBusAssetDamageImageBodyDto);
      const formData = new FormData();
formData.append('busAssetDamageImage', uploadBusAssetDamageImageBodyDto.busAssetDamageImage)
if(uploadBusAssetDamageImageBodyDto.performTextInpaint !== undefined && uploadBusAssetDamageImageBodyDto.performTextInpaint !== null) {
 formData.append('performTextInpaint', uploadBusAssetDamageImageBodyDto.performTextInpaint)
 }
if(uploadBusAssetDamageImageBodyDto.performTextInpaintPrompt !== undefined && uploadBusAssetDamageImageBodyDto.performTextInpaintPrompt !== null) {
 formData.append('performTextInpaintPrompt', uploadBusAssetDamageImageBodyDto.performTextInpaintPrompt)
 }

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/damageImages`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetDamageImageMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetDamageImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetDamageImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetDamageImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetDamageImageBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetDamageImage>>, {busAssetId: string;data: BodyType<UploadBusAssetDamageImageBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetDamageImage(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetDamageImageMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetDamageImage>>>
    export type ApiUploadBusAssetDamageImageMutationBody = BodyType<UploadBusAssetDamageImageBodyDto>
    export type ApiUploadBusAssetDamageImageMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetDamageImage = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetDamageImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetDamageImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetDamageImage>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetDamageImageBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetDamageImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetDamageImage = (
    busAssetId: MaybeRef<string | undefined | null>,
    deleteBusAssetDamageImageBodyDto: MaybeRef<DeleteBusAssetDamageImageBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
deleteBusAssetDamageImageBodyDto = unref(deleteBusAssetDamageImageBodyDto);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/damageImages`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteBusAssetDamageImageBodyDto
    },
      options);
    }
  


export const getApiDeleteBusAssetDamageImageMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetDamageImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetDamageImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetDamageImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetDamageImageBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetDamageImage>>, {busAssetId: string;data: BodyType<DeleteBusAssetDamageImageBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiDeleteBusAssetDamageImage(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetDamageImageMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetDamageImage>>>
    export type ApiDeleteBusAssetDamageImageMutationBody = BodyType<DeleteBusAssetDamageImageBodyDto>
    export type ApiDeleteBusAssetDamageImageMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetDamageImage = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetDamageImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetDamageImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetDamageImage>>,
        TError,
        {busAssetId: string;data: BodyType<DeleteBusAssetDamageImageBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetDamageImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAwaitBusAssetImageProcessing = (
    busAssetId: MaybeRef<string | undefined | null>,
    params: MaybeRef<ApiAwaitBusAssetImageProcessingParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
params = unref(params);
      
      return fetchApiInstance<AwaitBusAssetImageProcessingResponseDto>(
      {url: `/busAssets/${busAssetId}/images/awaitProcessing`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAwaitBusAssetImageProcessingQueryKey = (busAssetId: MaybeRef<string | undefined | null>,
    params: MaybeRef<ApiAwaitBusAssetImageProcessingParams>,) => {
    return ['busAssets',busAssetId,'images','awaitProcessing', ...(params ? [params]: [])] as const;
    }

    
export const getApiAwaitBusAssetImageProcessingQueryOptions = <TData = Awaited<ReturnType<typeof apiAwaitBusAssetImageProcessing>>, TError = ErrorType<BackendErrorEntity>>(busAssetId: MaybeRef<string | undefined | null>,
    params: MaybeRef<ApiAwaitBusAssetImageProcessingParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAwaitBusAssetImageProcessing>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAwaitBusAssetImageProcessingQueryKey(busAssetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAwaitBusAssetImageProcessing>>> = () => apiAwaitBusAssetImageProcessing(busAssetId,params, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(busAssetId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAwaitBusAssetImageProcessing>>, TError, TData> 
}

export type ApiAwaitBusAssetImageProcessingQueryResult = NonNullable<Awaited<ReturnType<typeof apiAwaitBusAssetImageProcessing>>>
export type ApiAwaitBusAssetImageProcessingQueryError = ErrorType<BackendErrorEntity>



export function useApiAwaitBusAssetImageProcessing<TData = Awaited<ReturnType<typeof apiAwaitBusAssetImageProcessing>>, TError = ErrorType<BackendErrorEntity>>(
 busAssetId: MaybeRef<string | undefined | null>,
    params: MaybeRef<ApiAwaitBusAssetImageProcessingParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAwaitBusAssetImageProcessing>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAwaitBusAssetImageProcessingQueryOptions(busAssetId,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiInpaintBusAssetImage = (
    busAssetId: MaybeRef<string | undefined | null>,
    inpaintBusAssetImageBodyDto: MaybeRef<InpaintBusAssetImageBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
inpaintBusAssetImageBodyDto = unref(inpaintBusAssetImageBodyDto);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/images/inpaint`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inpaintBusAssetImageBodyDto
    },
      options);
    }
  


export const getApiInpaintBusAssetImageMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInpaintBusAssetImage>>, TError,{busAssetId: string;data: BodyType<InpaintBusAssetImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInpaintBusAssetImage>>, TError,{busAssetId: string;data: BodyType<InpaintBusAssetImageBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInpaintBusAssetImage>>, {busAssetId: string;data: BodyType<InpaintBusAssetImageBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiInpaintBusAssetImage(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiInpaintBusAssetImageMutationResult = NonNullable<Awaited<ReturnType<typeof apiInpaintBusAssetImage>>>
    export type ApiInpaintBusAssetImageMutationBody = BodyType<InpaintBusAssetImageBodyDto>
    export type ApiInpaintBusAssetImageMutationError = ErrorType<BackendErrorEntity>

    export const useApiInpaintBusAssetImage = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInpaintBusAssetImage>>, TError,{busAssetId: string;data: BodyType<InpaintBusAssetImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiInpaintBusAssetImage>>,
        TError,
        {busAssetId: string;data: BodyType<InpaintBusAssetImageBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiInpaintBusAssetImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiSetBusAssetImageDetailFlag = (
    busAssetId: MaybeRef<string | undefined | null>,
    setBusAssetImageDetailFlagBodyDto: MaybeRef<SetBusAssetImageDetailFlagBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
setBusAssetImageDetailFlagBodyDto = unref(setBusAssetImageDetailFlagBodyDto);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/images/detailFlag`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setBusAssetImageDetailFlagBodyDto
    },
      options);
    }
  


export const getApiSetBusAssetImageDetailFlagMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetBusAssetImageDetailFlag>>, TError,{busAssetId: string;data: BodyType<SetBusAssetImageDetailFlagBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSetBusAssetImageDetailFlag>>, TError,{busAssetId: string;data: BodyType<SetBusAssetImageDetailFlagBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSetBusAssetImageDetailFlag>>, {busAssetId: string;data: BodyType<SetBusAssetImageDetailFlagBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiSetBusAssetImageDetailFlag(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSetBusAssetImageDetailFlagMutationResult = NonNullable<Awaited<ReturnType<typeof apiSetBusAssetImageDetailFlag>>>
    export type ApiSetBusAssetImageDetailFlagMutationBody = BodyType<SetBusAssetImageDetailFlagBodyDto>
    export type ApiSetBusAssetImageDetailFlagMutationError = ErrorType<BackendErrorEntity>

    export const useApiSetBusAssetImageDetailFlag = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetBusAssetImageDetailFlag>>, TError,{busAssetId: string;data: BodyType<SetBusAssetImageDetailFlagBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSetBusAssetImageDetailFlag>>,
        TError,
        {busAssetId: string;data: BodyType<SetBusAssetImageDetailFlagBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSetBusAssetImageDetailFlagMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadBusAssetCoverImage = (
    busAssetId: MaybeRef<string | undefined | null>,
    uploadBusAssetCoverImageBodyDto: MaybeRef<UploadBusAssetCoverImageBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
uploadBusAssetCoverImageBodyDto = unref(uploadBusAssetCoverImageBodyDto);
      const formData = new FormData();
formData.append('busAssetCoverImage', uploadBusAssetCoverImageBodyDto.busAssetCoverImage)
if(uploadBusAssetCoverImageBodyDto.performTextInpaint !== undefined && uploadBusAssetCoverImageBodyDto.performTextInpaint !== null) {
 formData.append('performTextInpaint', uploadBusAssetCoverImageBodyDto.performTextInpaint)
 }
if(uploadBusAssetCoverImageBodyDto.performTextInpaintPrompt !== undefined && uploadBusAssetCoverImageBodyDto.performTextInpaintPrompt !== null) {
 formData.append('performTextInpaintPrompt', uploadBusAssetCoverImageBodyDto.performTextInpaintPrompt)
 }

      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/coverImages`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadBusAssetCoverImageMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetCoverImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetCoverImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetCoverImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetCoverImageBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadBusAssetCoverImage>>, {busAssetId: string;data: BodyType<UploadBusAssetCoverImageBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiUploadBusAssetCoverImage(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadBusAssetCoverImageMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadBusAssetCoverImage>>>
    export type ApiUploadBusAssetCoverImageMutationBody = BodyType<UploadBusAssetCoverImageBodyDto>
    export type ApiUploadBusAssetCoverImageMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadBusAssetCoverImage = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadBusAssetCoverImage>>, TError,{busAssetId: string;data: BodyType<UploadBusAssetCoverImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadBusAssetCoverImage>>,
        TError,
        {busAssetId: string;data: BodyType<UploadBusAssetCoverImageBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadBusAssetCoverImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteBusAssetCoverImage = (
    busAssetId: MaybeRef<string | undefined | null>,
    deleteBusAssetCoverImageBodyDto: MaybeRef<DeleteBusAssetCoverImageBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
deleteBusAssetCoverImageBodyDto = unref(deleteBusAssetCoverImageBodyDto);
      
      return fetchApiInstance<BusAssetEntity>(
      {url: `/busAssets/${busAssetId}/coverImages`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteBusAssetCoverImageBodyDto
    },
      options);
    }
  


export const getApiDeleteBusAssetCoverImageMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetCoverImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetCoverImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetCoverImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetCoverImageBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteBusAssetCoverImage>>, {busAssetId: string;data: BodyType<DeleteBusAssetCoverImageBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiDeleteBusAssetCoverImage(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteBusAssetCoverImageMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteBusAssetCoverImage>>>
    export type ApiDeleteBusAssetCoverImageMutationBody = BodyType<DeleteBusAssetCoverImageBodyDto>
    export type ApiDeleteBusAssetCoverImageMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteBusAssetCoverImage = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteBusAssetCoverImage>>, TError,{busAssetId: string;data: BodyType<DeleteBusAssetCoverImageBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteBusAssetCoverImage>>,
        TError,
        {busAssetId: string;data: BodyType<DeleteBusAssetCoverImageBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiDeleteBusAssetCoverImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetBusAssets = (
    params?: MaybeRef<ApiGetBusAssetsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetBusAssetsResponseDto>(
      {url: `/busAssets`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetBusAssetsQueryKey = (params?: MaybeRef<ApiGetBusAssetsParams>,) => {
    return ['busAssets', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetBusAssetsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetBusAssets>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetBusAssetsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBusAssets>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetBusAssetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetBusAssets>>> = () => apiGetBusAssets(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetBusAssets>>, TError, TData> 
}

export type ApiGetBusAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetBusAssets>>>
export type ApiGetBusAssetsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetBusAssets<TData = Awaited<ReturnType<typeof apiGetBusAssets>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetBusAssetsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBusAssets>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetBusAssetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiPostCloneBusAsset = (
    busAssetId: MaybeRef<string | undefined | null>,
    postCloneBusAssetBodyDto: MaybeRef<PostCloneBusAssetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
postCloneBusAssetBodyDto = unref(postCloneBusAssetBodyDto);
      
      return fetchApiInstance<AssetEntity>(
      {url: `/busAssets/${busAssetId}/clone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCloneBusAssetBodyDto
    },
      options);
    }
  


export const getApiPostCloneBusAssetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostCloneBusAsset>>, TError,{busAssetId: string;data: BodyType<PostCloneBusAssetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPostCloneBusAsset>>, TError,{busAssetId: string;data: BodyType<PostCloneBusAssetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPostCloneBusAsset>>, {busAssetId: string;data: BodyType<PostCloneBusAssetBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiPostCloneBusAsset(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPostCloneBusAssetMutationResult = NonNullable<Awaited<ReturnType<typeof apiPostCloneBusAsset>>>
    export type ApiPostCloneBusAssetMutationBody = BodyType<PostCloneBusAssetBodyDto>
    export type ApiPostCloneBusAssetMutationError = ErrorType<BackendErrorEntity>

    export const useApiPostCloneBusAsset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostCloneBusAsset>>, TError,{busAssetId: string;data: BodyType<PostCloneBusAssetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPostCloneBusAsset>>,
        TError,
        {busAssetId: string;data: BodyType<PostCloneBusAssetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPostCloneBusAssetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiCloneAlreadySoldBusAsset = (
    busAssetId: MaybeRef<string | undefined | null>,
    postCloneAlreadySoldBusAssetBodyDto: MaybeRef<PostCloneAlreadySoldBusAssetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
postCloneAlreadySoldBusAssetBodyDto = unref(postCloneAlreadySoldBusAssetBodyDto);
      
      return fetchApiInstance<AssetEntity>(
      {url: `/busAssets/${busAssetId}/cloneSoldAsset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCloneAlreadySoldBusAssetBodyDto
    },
      options);
    }
  


export const getApiCloneAlreadySoldBusAssetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCloneAlreadySoldBusAsset>>, TError,{busAssetId: string;data: BodyType<PostCloneAlreadySoldBusAssetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCloneAlreadySoldBusAsset>>, TError,{busAssetId: string;data: BodyType<PostCloneAlreadySoldBusAssetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCloneAlreadySoldBusAsset>>, {busAssetId: string;data: BodyType<PostCloneAlreadySoldBusAssetBodyDto>}> = (props) => {
          const {busAssetId,data} = props ?? {};

          return  apiCloneAlreadySoldBusAsset(busAssetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCloneAlreadySoldBusAssetMutationResult = NonNullable<Awaited<ReturnType<typeof apiCloneAlreadySoldBusAsset>>>
    export type ApiCloneAlreadySoldBusAssetMutationBody = BodyType<PostCloneAlreadySoldBusAssetBodyDto>
    export type ApiCloneAlreadySoldBusAssetMutationError = ErrorType<BackendErrorEntity>

    export const useApiCloneAlreadySoldBusAsset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCloneAlreadySoldBusAsset>>, TError,{busAssetId: string;data: BodyType<PostCloneAlreadySoldBusAssetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCloneAlreadySoldBusAsset>>,
        TError,
        {busAssetId: string;data: BodyType<PostCloneAlreadySoldBusAssetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiCloneAlreadySoldBusAssetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    